/**
*  archivo para exportar todas las expresiones regulares del proyecto.
*/

export const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;

export const USER_REGEXP = /^[A-Za-z][A-Za-z0-9\-._]*$/;

export const ONLYNUMBERS_REGEXP = /^\d+$/;

export const NAME_REGEXP = /^[ A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ.-]+$/;

export const COMPANY_NAME_REGEXP = /^[ A-Za-z0-9äÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ.-]+$/;

export const PASSWORD_REGEXP = /^(?=.*\d)(?=.*[\u0021-\u002F\u003A-\u0040\u005B-\u0060])(?=.*[A-Z])(?=.*[\w])\S+$/;

export const PASSPORT_REGEXP = /^[A-Za-z-\d]+$/;

export const LETTERS_AND_NUMBERS = /[A-Za-z][0-9]+/;

export const CONTENT_LETTER_UPPER_REGEXP = /[A-Z]+/;

export const CONTENT_LETTER_LOWER_REGEXP = /[a-z]+/;

export const CHARACTERS_ESPECIAL_REGEXP = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/;

export const PHONE_CHARACTERS_REGEXP = /^([+]?)([0-9])+$/;

export const IP_VALIDATOR = /^((25[0-5]|2[0-4][\d]|[01]?[\d][\d]?)\.){3}(25[0-5]|2[0-4][\d]|[01]?[\d][\d]?)$/

export const CIRIF_REGEXP = /^([V|v|g|G|j|J|e|E]{1})-((\d{6,8})|((\d{8})-(\d{1})))$/;

export const TLF_REGEXP = /^\d{4}\-\d{3}\-\d{2}\-\d{2}/;

export const COORDINATE_REGEXP = /^-?[0-9]+([\.][0-9]*)?$/;

export const MAC_ADDRESS = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

export const RIF_REGEXP = /^[VEPJG]{1}-?\d{8}-?\d{1}$/;

